import React from "react";
import { Typography } from "@mui/material";
import useStyles from "./style";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import jsonUtils from "../../utils/jsonUtils";

const CustomizedAxisTick = (...args) => {
  const { x, y, stroke, payload } = args[0];
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={15} fontSize={14} textAnchor="end" fill="#666" transform="rotate(-30)">
        {payload.value}
      </text>
    </g>
  );
};

const ComponentOperacaoDetalhada = (props) => {
  const operacao = props.operacao;
  const classes = useStyles();

  const vencimentos = operacao.VENCIMENTOS

  const data = vencimentos.map((vencimento) => {

    const vencimentoValor = vencimento.VALOR;
    const vencimentoFormatado = parseFloat((vencimentoValor || "0").replace(',', '.'));

    const descricao = vencimento.DESCRICAO;
    const descricaoFormatado = descricao.replace(/CREDITOS A VENCER COM PRAZO|CREDITOS A VENCER|CREDITOS VENCIDOS|LIMITE DE CREDITO COM VENCIMENTO ACIMA|LIMITE DE CREDITO COM VENCIMENTO/g, '');

    return { name: descricaoFormatado, vendas: vencimentoFormatado };
  });

  const valor = operacao.TOTAL;
  const valorNumerico = parseFloat((valor || "0").replace(',', '.'));
  const valorFormatado = valorNumerico.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  const modalidade = operacao.MODALIDADE.DESCRICAO;
  const subModalidade = operacao.SUB_MODALIDADE.DESCRICAO;

  const percentual = operacao.PERCENTUAL;
  const percentualFormatado = (percentual || "0").replace(',', '.');

  return (
    <div className={classes.component}>
      <div className={classes.alignComponents}>
        <div className={classes.align}>
          <Typography
            variant="h6"
            fontWeight="700"
            className={classes.doc}>
            Modalidade
          </Typography>

          <div className={classes.componentDoc}>
            <p className={classes.para}>{modalidade}</p>
          </div>
        </div>

        <div className={classes.align}>
          <Typography
            variant="h6"
            fontWeight="700"
            className={classes.doc}>
            Sub-modalidade
          </Typography>

          <div className={classes.componentCred}>
            <p className={classes.paraCred}>{subModalidade}</p>
          </div>
        </div>

        <div className={classes.alignConsolidado}>
          <Typography
            variant="h6"
            fontWeight="700"
            color="#938FA3"
            marginTop="5px">
            Valor total consolidado
          </Typography>

          <Typography
            variant="h4"
            fontWeight="800"
            color="#16325C"
            marginLeft="20px">
            {valorFormatado}
          </Typography>
        </div>

        <div className={classes.align}>
          <Typography
            variant="h6"
            fontWeight="700"
            className={classes.doc}>
            Percentual
          </Typography>

          <div className={classes.componentPor}>
            <p className={classes.para}>{percentualFormatado}</p>
          </div>
        </div>
      </div>

      <div className={classes.grafico}>
        <Typography
          variant="h6"
          fontWeight="700"
          color="#938FA3"
          marginLeft="140px"
          fontSize="16px">
          Vencimentos (Valor x Prazo)
        </Typography>
        <BarChart width={500} height={240} barSize={25} data={data} margin={{ top: 0, right: 20, left: 10, bottom: 50 }}>
          <XAxis dataKey="name" tick={<CustomizedAxisTick />} />
          <YAxis tickCount={4} type="number" />
          <Bar dataKey="vendas" fill="#16325C" radius={20} minPointSize={20} />
        </BarChart>
      </div>

    </div>
  );
};

export default ComponentOperacaoDetalhada;